import type { Lang } from '@app/shared';

/**
 * Текст политики конфиденциальности. Составлен под Закон РУз «О персональных данных»
 * (№ ЗРУ-547 от 02.07.2019), включая ст. 27¹ о хранении данных граждан Узбекистана
 * на территории республики.
 *
 * ВНИМАНИЕ: реквизиты оператора в квадратных скобках — заполнить перед выкатом.
 * Текст — рабочая редакция, не юридическое заключение; перед запуском её стоит показать юристу.
 *
 * Лежит в коде, а не в словаре `dict`: это документ, а не строки интерфейса.
 */
export const POLICY_UPDATED = '21.09.2026';

export const POLICY: Readonly<Record<Lang, readonly (readonly [string, string])[]>> = {
  ru: [
    [
      '1. Кто обрабатывает данные',
      'Оператор персональных данных — [наименование / ИП, ИНН, юридический адрес], далее «мы». Политика действует для сервиса онлайн-записи Kanvel — мини-приложения и бота @KanvelBot в Telegram. Начиная пользоваться сервисом, вы соглашаетесь с этой политикой.',
    ],
    [
      '2. Какие данные мы получаем',
      'Из Telegram: ваш идентификатор, имя, username, фото профиля и язык — ровно то, что Telegram передаёт мини-приложению. Данные о записях: организация, услуга, специалист, время и статус визита, отметки о неявках, ваши оценки визитов. Текст пожеланий, если вы их отправляете. У владельцев бизнеса — также название, адрес, услуги, цены и график работы организации. Мы НЕ запрашиваем номер телефона, паспортные и платёжные данные.',
    ],
    [
      '3. Зачем',
      'Чтобы записать вас к специалисту и напомнить о визите; чтобы организация видела свои записи и статистику; чтобы ограничивать злоупотребления (массовые записи без явки); чтобы отвечать на ваши обращения и улучшать сервис. Рекламных рассылок нет, бот пишет только по событиям ваших записей.',
    ],
    [
      '4. Кому мы передаём данные',
      'Организации, в которую вы записались, — ваше имя и данные записи; после подтверждения записи организация может связаться с вами через Telegram. Сведения о неявках учитываются в рамках всего сервиса. Данные передаются Telegram в объёме, необходимом для работы бота. Мы не продаём и не передаём данные третьим лицам в иных целях, кроме случаев, прямо предусмотренных законом.',
    ],
    [
      '5. Где и сколько хранятся',
      'Данные хранятся на серверах, расположенных на территории Республики Узбекистан. Мы храним их, пока вы пользуетесь сервисом и пока это нужно для целей из раздела 3 или требуется законом. Резервные копии хранятся ограниченный срок и затем удаляются.',
    ],
    [
      '6. Как мы защищаем данные',
      'Соединение шифруется (HTTPS); каждый запрос проверяется подписью Telegram; доступ к базе данных есть только у сервера приложения и ограниченного круга сотрудников.',
    ],
    [
      '7. Ваши права',
      'Вы вправе знать, какие ваши данные мы обрабатываем, получить их копию, потребовать исправления или удаления, а также отозвать согласие на обработку. Для этого напишите нам через раздел «Пожелания» или на [e-mail]. Мы ответим в сроки, установленные законом. После удаления данных пользоваться записью будет невозможно.',
    ],
    [
      '8. Изменения',
      'Мы можем обновлять политику. Актуальная редакция всегда доступна в приложении; дата редакции указана ниже.',
    ],
  ],
  uz: [
    [
      '1. Maʼlumotlarga kim ishlov beradi',
      'Shaxsga doir maʼlumotlar operatori — [nomi / YaTT, STIR, yuridik manzil], bundan buyon «biz». Siyosat Telegramdagi Kanvel onlayn yozilish xizmati — mini-ilova va @KanvelBot boti uchun amal qiladi. Xizmatdan foydalanishni boshlash bilan siz ushbu siyosatga rozilik bildirasiz.',
    ],
    [
      '2. Qanday maʼlumotlarni olamiz',
      'Telegramdan: identifikatoringiz, ismingiz, username, profil rasmi va til — Telegram mini-ilovaga aynan nimani uzatsa, shu. Yozuvlar haqida: tashkilot, xizmat, mutaxassis, tashrif vaqti va holati, kelmaganlik belgilari, tashriflarga bergan baholaringiz. Takliflar matni, agar ularni yuborsangiz. Biznes egalaridan — shuningdek tashkilot nomi, manzili, xizmatlari, narxlari va ish jadvali. Biz telefon raqami, pasport va toʻlov maʼlumotlarini SOʻRAMAYMIZ.',
    ],
    [
      '3. Nima uchun',
      'Sizni mutaxassisga yozish va tashrif haqida eslatish uchun; tashkilot oʻz yozuvlari va statistikasini koʻrishi uchun; suiisteʼmollarni (kelmasdan ommaviy yozilish) cheklash uchun; murojaatlaringizga javob berish va xizmatni yaxshilash uchun. Reklama xabarlari yoʻq, bot faqat yozuvlaringiz boʻyicha voqealarda yozadi.',
    ],
    [
      '4. Maʼlumotlarni kimga beramiz',
      'Siz yozilgan tashkilotga — ismingiz va yozuv maʼlumotlari; yozuv tasdiqlangandan keyin tashkilot siz bilan Telegram orqali bogʻlanishi mumkin. Kelmaganlik haqidagi maʼlumotlar butun xizmat doirasida hisobga olinadi. Maʼlumotlar Telegramga bot ishlashi uchun zarur hajmda uzatiladi. Biz maʼlumotlarni sotmaymiz va qonunda bevosita nazarda tutilgan hollardan tashqari uchinchi shaxslarga bermaymiz.',
    ],
    [
      '5. Qayerda va qancha saqlanadi',
      'Maʼlumotlar Oʻzbekiston Respublikasi hududida joylashgan serverlarda saqlanadi. Biz ularni siz xizmatdan foydalanayotgan va 3-boʻlimdagi maqsadlar uchun kerak boʻlgan yoki qonun talab qilgan muddatda saqlaymiz. Zaxira nusxalari cheklangan muddat saqlanadi va keyin oʻchiriladi.',
    ],
    [
      '6. Maʼlumotlarni qanday himoya qilamiz',
      'Ulanish shifrlanadi (HTTPS); har bir soʻrov Telegram imzosi bilan tekshiriladi; maʼlumotlar bazasiga faqat ilova serveri va cheklangan xodimlar doirasi kirish huquqiga ega.',
    ],
    [
      '7. Sizning huquqlaringiz',
      'Siz qaysi maʼlumotlaringizga ishlov berayotganimizni bilish, ularning nusxasini olish, tuzatish yoki oʻchirishni talab qilish hamda ishlov berishga rozilikni qaytarib olish huquqiga egasiz. Buning uchun «Takliflar» boʻlimi orqali yoki [e-mail] manziliga yozing. Biz qonunda belgilangan muddatlarda javob beramiz. Maʼlumotlar oʻchirilgandan keyin yozilishdan foydalanib boʻlmaydi.',
    ],
    [
      '8. Oʻzgarishlar',
      'Biz siyosatni yangilashimiz mumkin. Amaldagi tahrir doimo ilovada mavjud; tahrir sanasi quyida koʻrsatilgan.',
    ],
  ],
};
